import { render, staticRenderFns } from "./SelectedExternalForm.vue?vue&type=template&id=5c3bf47e&scoped=true"
import script from "./SelectedExternalForm.vue?vue&type=script&lang=ts"
export * from "./SelectedExternalForm.vue?vue&type=script&lang=ts"
import style0 from "./SelectedExternalForm.vue?vue&type=style&index=0&id=5c3bf47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3bf47e",
  null
  
)

export default component.exports